import { getBrowserRuntimeEnv } from './browser';
import { getNodeRuntimeEnv } from './node';
import type { RuntimeEnv } from './types';

let runtimeEnv: RuntimeEnv | undefined;

const isNodeRuntime = (): boolean =>
  typeof (globalThis as { process?: { versions?: { node?: string } } }).process?.versions?.node === 'string';

export const setRuntimeEnv = (value: RuntimeEnv): void => {
  runtimeEnv = value;
};

export const getRuntimeEnv = (): RuntimeEnv => {
  if (runtimeEnv) {
    return runtimeEnv;
  }

  if (isNodeRuntime() || typeof window === 'undefined' || typeof document === 'undefined') {
    // Cache the node env as well: rebuilding it re-resolves the document
    // (and may touch the domino adapter) on every call. Anything that needs
    // to override the environment must do so before the first access —
    // either via setRuntimeEnv or by providing globalThis.document.
    runtimeEnv = getNodeRuntimeEnv();
    return runtimeEnv;
  }

  runtimeEnv = getBrowserRuntimeEnv();
  return runtimeEnv;
};

export const getRuntimeDocument = (): Document => getRuntimeEnv().document;

export const getRuntimeWindow = (): Window & typeof globalThis => getRuntimeEnv().window;

export const getDevicePixelRatio = (): number =>
  Math.max(getRuntimeWindow().devicePixelRatio || 1, 1);

export { getBrowserRuntimeEnv } from './browser';
export type { RuntimeEnv } from './types';
